import { Centrifuge } from "centrifuge";

// Транспорты по порядку: WebSocket, при неудаче — SSE. Всё под `/connection/`,
// который nginx проксирует в Centrifugo. Команды клиента при SSE идут через
// эмуляцию Centrifugo (`/connection/emulation`).
export const createCentrifuge = (getToken: () => Promise<string>): Centrifuge => {
  const { protocol, host } = window.location;
  const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
  return new Centrifuge(
    [
      { transport: "websocket", endpoint: `${wsProtocol}//${host}/connection/websocket` },
      { transport: "sse", endpoint: `${protocol}//${host}/connection/sse` },
    ],
    {
      getToken,
      emulationEndpoint: `${protocol}//${host}/connection/emulation`,
    },
  );
};
